"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

import { logoInputs } from "./inputs/logoInputs.builder";

export const LogoComponent: RegisteredComponent = {
  name: "Logo",
  component: dynamic(async () => withValidation(logoInputs, (await import("./Logo")).Logo, "Logo")),
  inputs: logoInputs,
};
